var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetrolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2819",
    "data-name": "Group 2819",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.709,
    height: 11.531,
    viewBox: "0 0 9.709 11.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 9.709,
    height: 11.531,
    fill: "#313a41"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    "data-name": "Group 2818",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M9.571,11.144a1.575,1.575,0,0,0-.247,0l-.527,0,0-.257a.577.577,0,0,0-.637-.622l0-.927a.965.965,0,0,0,.336.214l.038.012c.573.179,1.016-.343,1.039-.9V3.682c0-.078,0-.159,0-.237a.743.743,0,0,0-.059-.153,1.232,1.232,0,0,0-.075-.246,3.93,3.93,0,0,0-1.157-1.3c-.032-.018-.069-.019-.1-.039l0-.52a1.489,1.489,0,0,0-.007-.27l0-.011C8.029.179,5.812.032,5.126,0L4.231,0A9.039,9.039,0,0,0,2.217.285c-.387.107-.932.282-.986.752a2.9,2.9,0,0,0-.005.33v8.827c0,.019.011.065,0,.076a.953.953,0,0,0-.3.025.537.537,0,0,0-.39.555v.29H.281a.714.714,0,0,0-.146,0c-.21.046-.16.367.046.38.093.006.189,0,.282,0h8.91a1.263,1.263,0,0,0,.212,0c.165-.03.169-.349-.015-.381m-.5-7.981a2.982,2.982,0,0,1-.839-1.01,4.339,4.339,0,0,1,.839,1.01m-.915-.455,0-.006.1.158a3.476,3.476,0,0,0,.648.666L9,3.6c.064.059.124.046.208.049V8.505a.786.786,0,0,1-.163.569.429.429,0,0,1-.56.066A1.211,1.211,0,0,1,8.157,8.1l0-5.227a1.161,1.161,0,0,0,0-.16M1.594,10.133V1.223a.379.379,0,0,1,.08-.288A5.793,5.793,0,0,1,4.143.384l.278,0,.939.014A10.793,10.793,0,0,1,6.835.581c.253.05.952.17.969.5.014.28-.014.56-.014.84l0,8.344H1.6a.493.493,0,0,1,0-.136m2.277,1.008H.914v-.2c0-.137-.013-.28.158-.292s.333,0,.5,0H8.141c.115,0,.191-.018.253.1l0,.008a.363.363,0,0,1,.02.157v.235Z",
    transform: "translate(0)",
    fill: "#313a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10614",
    "data-name": "Path 10614",
    d: "M60.789,24.8c0,.361.29.366.568.366h4.476a1.358,1.358,0,0,0,.211,0,.383.383,0,0,0,.278-.288,1.816,1.816,0,0,0,0-.269V22.18c0-.409-.311-.5-.654-.592a9.116,9.116,0,0,0-2.466-.223l-.244.01c-.413.015-2.086.106-2.165.669a2.286,2.286,0,0,0,0,.307Zm.374-2.7a.689.689,0,0,1,.27-.115,7.144,7.144,0,0,1,1.761-.247l.9,0,.638.054a3.126,3.126,0,0,1,1.222.315,1.657,1.657,0,0,1,0,.265v2.418H61.161c-.011-.187,0-.379,0-.567v-1.75a3.291,3.291,0,0,1,.005-.375",
    transform: "translate(-58.843 -20.682)",
    fill: "#313a41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrolIcon);
export default __webpack_public_path__ + "static/media/petrol_icon.de41019dc5d5311dc55eb49da792367d.svg";
export { ForwardRef as ReactComponent };